import { useSelector, useDispatch } from 'react-redux';
import useRouter from './useRouter';
import { signOut } from '../actions/auth';
import routes from '../utils/variables/routes';
import { agentType } from '../utils/variables';
import { getAccessToken } from '../storage/accessToken';
import { removeSessionData } from '../utils/functions';
// import { getStore } from '../store';
// import { expiresAtStorage } from '../utils/variables';

export const useSignOut = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  dispatch(signOut.signOutAction()).then(() => {
    removeSessionData();
    // // console.log('Your Done!');
    router.replace(routes.auth.signIn);
    // setTimeout(() => {
    // }, 200);
  });
};

export const validateAuth = (state, dontRevalidate) => {
  const user = state?.auth?.user;
  const usertype = state?.auth?.usertype;
  let isAuthenticated = state?.auth?.isAuthenticated;
  let revalidate = false;
  let isExpired = false;

  const expiresIn = user?.expiresIn;
  const clientExpiresIn = user?.clientExpiresIn;
  const logInTime = user?.logInTime;
  const nowTime = new Date().getTime();
  const accessToken = getAccessToken();

  if (accessToken && user && user.accessToken) {
    if (expiresIn) {
      const expiresAt = parseInt(expiresIn, 10) * 1000 + parseInt(logInTime, 10);
      // // console.log('expiresAt: ', expiresAt);
      const isNotExpired = user && user.accessToken && nowTime < expiresAt;
      const clientExpiresAt =
        parseInt(clientExpiresIn, 10) * 1000 + parseInt(logInTime, 10);
      // // console.log('clientExpiresAt: ', clientExpiresAt);
      const isClientNotExpired = user && user.accessToken && nowTime < clientExpiresAt;
      if (isNotExpired) {
        isExpired = false;
        // // console.log('isNotExpired: ', isNotExpired);
        if (isClientNotExpired) {
          // // console.log('isClientNotExpired: ', isClientNotExpired);
          isAuthenticated = true;
          revalidate = false;
        } else if (dontRevalidate) {
          isAuthenticated = true;
          revalidate = false;
        } else {
          isAuthenticated = true;
          revalidate = true;
        }
      } else {
        // // console.log('isExpired: ', !isNotExpired);
        isExpired = true;

        if (dontRevalidate) {
          isAuthenticated = false;
          revalidate = false;
        } else {
          // isAuthenticated = false;
          revalidate = false;
          isAuthenticated = false;
        }
        // isAuthenticated = !!(user && user.accessToken);
      }
    } else {
      isAuthenticated = false; //! !(user && user.accessToken);
      revalidate = false;
      isExpired = false;
    }
  }

  // isAuthenticated = isAuthenticated && accessToken;

  return { isAuthenticated, revalidate, isExpired, user, usertype };
};

/*
 else {
    isAuthenticated = false;
    revalidate = false;
    isExpired = false;
  }

  */
export const useAuthValidation = () => {
  const { isAuthenticated } = useSelector(state => validateAuth(state));

  return isAuthenticated;
};

export const getUserIds = state => {
  // console.log('state: ', state);
  const { user, usertype } = state?.auth || {};
  const userIds = {
    accessToken: user?.accessToken,
    authId: user?.id,
    customerId: user?.customer?.id,
    agentId: user?.agent?.id || user?.agent?._id,
    isAgent: !!((user?.agent?.id || user?.agent?._id) && usertype === agentType),
    usertype,
    usersubtype: user?.agentType,
  };
  return userIds;
};

export default {
  useAuthValidation,
  validateAuth,
  useSignOut,
  getUserIds,
};

/*
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('expiresAt');
  setTimeout(() => {
    history.replace('/authcheck');
  }, 200);
  */
// };

// export const handleAuth = () => {
/*
  localStorage.setItem('access_token', authResult.accessToken);
  localStorage.setItem('id_token', authResult.idToken);

  const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
  localStorage.setItem('expiresAt', expiresAt);

  this.getProfile();
  setTimeout(() => {
    history.replace('/authcheck');
  }, 600);
  */
// };
